import { styled } from '@mui/material/styles';
import { Box, Stack } from '@mui/material';

/** basic 크기 모달 최대 너비. 모달 폭을 기준으로 레이아웃을 맞추는 쪽(V2 결재 작성 모달 등)이 참조 */
export const MODAL_BASIC_MAX_WIDTH = 1168;

export const ModalInner = styled(Stack)`
  flex-direction: column;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100vw - 80px);
  max-width: ${MODAL_BASIC_MAX_WIDTH}px;
  /* 폰처럼 좁은 화면에서는 화면 밖으로 넘치지 않게 (좌우 16px 여백) */
  min-width: min(688px, calc(100vw - 32px));
  max-height: calc(100vh - 80px);
  border-radius: 8px;
  background-color: var(--dk-bg, white);
  overflow: hidden;
  transition: width 0.3s ease, height 0.3s ease, max-width 0.3s ease,
    max-height 0.3s ease;
  &:focus-visible {
    outline: 0;
  }
  &.x-small {
    min-width: min(438px, calc(100vw - 32px));
    max-width: 438px;
    .modal-body {
      --modal-padding-top: 24px;
      --modal-padding-x: 20px;
      padding: 24px 20px;
    }
  }
  &.small {
    min-width: auto;
    max-width: 688px;
  }
  &.fixedHeight {
    height: calc(100vh - 80px);
  }
  &.expand {
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    border-radius: 0;
    .modal-header {
      border-radius: 0;
    }
    .modal-body {
      max-height: calc(100% - 60px);
    }
    /* 본문 여백이 없을 땐 max-height 제한을 풀어 하단 흰 띠가 남지 않게 한다. */
    .modal-body.no-padding {
      max-height: 100%;
    }
  }
`;

export const ModalHeader = styled(Stack)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: var(--dk-bg-subtle, rgba(249, 250, 251, 0.9));
  backdrop-filter: blur(6px);
  border-bottom: 1px solid var(--dk-line, #e7e9ec);
  padding: 6px 12px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;

  h1 {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
    margin: 0;
    font-weight: 500;
    font-size: 16px;
    color: var(--dk-text, black);
    button {
      padding: 4px;
    }
    /* 뒤로가기: 아이콘 24x24, 타이틀과 간격 4px (Portal_Library 스펙).
       버튼 자체 padding 이 있으면 간격이 8px 로 벌어지므로 아이콘 박스에 딱 맞춘다. */
    button.back {
      padding: 0;
      min-width: 24px;
    }
  }
`;
export const ModalBody = styled(Box)`
  position: relative;
  flex: 1;
  max-height: 100%;
  padding: 32px 24px;
  overflow: auto;
  background-color: var(--dk-bg, white);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  /* 본문 패딩을 상쇄해 모달 폭·최상단에 붙이는 자식(전폭 띠, sticky 툴바 등)이 참조 */
  --modal-padding-top: 32px;
  --modal-padding-x: 24px;
  &.no-padding {
    padding: 0;
    /* 단위 없는 0 은 calc(var() * -1) 소비처에서 number 가 되어 선언 전체가 무효(unset)
       — sticky 툴바 top 이 auto 로 풀리므로 0px 유지 */
    --modal-padding-top: 0px;
    --modal-padding-x: 0px;
    /* 본문이 가장자리까지 차므로 하단 모서리 둥글기 제거 (다크 뷰어 등). */
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
`;

export const ModalFooter = styled(Box)`
  position: relative;
  height: auto;
  padding: 20px 24px;
  background-color: var(--dk-bg-subtle, #f9fafb);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;
